export default "__VITE_ASSET__BKkFvraE__"